import React from 'react';
import {connect} from 'react-redux';
import CONSTANTS from './constants.js';
import instrumentCreator from './actionCreators'
import './Display.scss'

class Display extends React.Component{
    constructor(props){
        super(props);
    }
    render(){
        return(
            <div id='display'>{this.props.name}</div>
        );
    }
}

export default connect(CONSTANTS.mapStateToProps)(Display);